<template>
  <span class="fw-bold" style="display: inline-block; width: 2ch; text-align: right;" v-html="displayText"></span>
</template>

<script setup lang="ts">
import Duration from "@/guiide/ts/temporal/duration";
import { getDuration } from "@/guiide/ts/temporal/durationHelper";
import { ref, watch, computed } from "vue";

const props = defineProps({
    duration: {
        type: Number,
        default: 0
    }
});

const durationForModel = ref<Duration>(new Duration(0, 0, 0, 0, 0));

watch(
  () => props.duration,
  (newDuration: number) => {
    durationForModel.value = getDuration(newDuration);
  }
)

const displayText = computed<string>(() => {
  if (durationForModel.value.isNonZeroButLessThanOneYear()) {
    return getFractionHtml();
  }

  const fractionHtml = getFractionHtml();
  
  return `${durationForModel.value.years} ${fractionHtml}`;
});

function getFractionHtml(): string {
  return durationForModel.value.hasFraction()
    ? `<sup>${durationForModel.value.numerator}</sup>/<sub>${durationForModel.value.denominator}</sub>`
    : "&nbsp;&nbsp;&nbsp;";
}
</script>
